import React, { useEffect, useState } from 'react';
import HorizontalScroll from './HorizontalScroll';
import { fetchData, exercisesOptions } from '../utils/FetchData';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';

function Search({ setExercises, setBodyPart }) {
  // State variables for the search query and body parts list
  const [search, setSearch] = useState('');
  const [bodyParts, setBodyParts] = useState([]);

  // useEffect hook to fetch the list of body parts when the component mounts
  useEffect(() => {
    const fetchBodyParts = async () => {
      try {
        // Fetch body part data from the API
        const response = await fetch(
          'https://exercisedb.p.rapidapi.com/exercises/bodyPartList',
          exercisesOptions
        );

        // Check if the response is successful
        if (!response.ok) {
          throw new Error('Failed to fetch body part data');
        }

        // Parse the response data
        const bodyPartData = await response.json();

        // Update the state with the body parts list
        setBodyParts(['all', ...bodyPartData]);
      } catch (error) {
        // Handle errors if any
        console.error('Error fetching body part data:', error);
      }
    };
    fetchBodyParts(); // Call the fetchBodyParts function
  }, []); // Empty dependency array means this effect runs only once, on component mount

  // Function to handle search
  const handleSearch = async () => {
    // Check if search query is not empty
    if (search.length > 0) {
      try {
        // Fetch exercise data from the API
        const exerciseData = await fetchData(
          'https://exercisedb.p.rapidapi.com/exercises',
          exercisesOptions
        );

        // Filter exercises based on search query
        const searchExercises = exerciseData.filter((exercise) =>
          [
            exercise?.name?.toLowerCase(),
            exercise?.target?.toLowerCase(),
            exercise?.equipment?.toLowerCase(),
            exercise?.bodyPart?.toLowerCase(),
          ].some((item) => item.includes(search.toLowerCase()))
        );

        // Clear search input and update exercises state with filtered data
        setSearch('');
        setExercises(searchExercises);
      } catch (error) {
        // Handle errors if any
        console.error('Error fetching exercise data:', error);
      }
    }
  };

  // Function to handle Enter key press in search input
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  // JSX rendering
  return (
    <Stack alignItems="center" mt="37px" justifyContent="center" p="20px">
      <Typography fontWeight={700} sx={{ fontSize: { lg: '44px', xs: '30px' } }} 
      mb="49px" textAlign="center">
        Awesome Exercises You Should Know
      </Typography>
      <Box position="relative" mb="72px">
        {/* Search input */}
        <TextField
          height="76px"
          sx={{
            input: {
              fontWeight: '700',
              border: 'none',
              outline: 'none',
            },
            width: { lg: '1170px', xs: '350px' },
            backgroundColor: '#fff',
            outline: 'none',
            border: 'none',
          }}
          value={search}
          onChange={(e) => setSearch(e.target.value.toLowerCase())}
          placeholder="Search Exercises"
          type="text"
          onKeyUp={handleKeyPress}
        />
        {/* Search button */}
        <Button
          className="hover:text-black"
          sx={{
            bgcolor: '#FF2625',
            color: '#fff',
            textTransform: 'none',
            width: { lg: '173px', xs: '80px' },
            height: '56px',
            position: 'absolute',
            right: '0px',
            fontSize: { lg: '20px', xs: '14px' },
          }}
          onClick={handleSearch}
        >
          Search
        </Button>
      </Box>
      {/* Horizontal scroll for body parts */}
      <Stack sx={{ position: 'relative', width: '100%', p: '20px' }}
       direction="row">
        <HorizontalScroll data={bodyParts} setBodyPart={setBodyPart} />
      </Stack>
    </Stack>
  );
}

export default Search;
